"use strict";

exports.__esModule = true;
exports.RcMask = RcMask;

var _react = _interopRequireDefault(require("react"));

var _reactHooks = require("@okee-uikit/react-hooks");

var _excluded = ["show", "defaultStyle", "style"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DEFAULT_STYLE = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
};

function RcMask(props) {
  var _props$show = props.show,
      show = _props$show === void 0 ? false : _props$show,
      _props$defaultStyle = props.defaultStyle,
      defaultStyle = _props$defaultStyle === void 0 ? true : _props$defaultStyle,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      extra = _objectWithoutPropertiesLoose(props, _excluded);

  var zIndex = style.zIndex;

  if (defaultStyle && typeof zIndex !== 'number') {
    zIndex = (0, _reactHooks.getZIndex)();
  }

  return _react.default.createElement("div", _extends({}, extra, {
    style: _extends({}, defaultStyle ? DEFAULT_STYLE : {}, style, {
      zIndex: zIndex,
      display: !show ? 'none' : 'block'
    })
  }));
}